import { render, staticRenderFns } from "./OverallData.vue?vue&type=template&id=75c8b279&"
import script from "./OverallData.vue?vue&type=script&lang=js&"
export * from "./OverallData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports